export default __webpack_public_path__ + "cc9ce8194a9f6c9adc103add2f0ff79c.png";